import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isUsingMagicLinkAuthen } from '../helpers';
import { LEGACY_PORTAL_URL } from '../constants/legacy';

const LegacyRedirectGate = () => {
  const location = useLocation();

  useEffect(() => {
    // Allow Magic Link flows to proceed inside the legacy app; redirect everything else to the new portal.
    const isMagicLinkFlow = isUsingMagicLinkAuthen();
    if (!isMagicLinkFlow) {
      window.location.replace(LEGACY_PORTAL_URL);
    }
  }, [location.pathname]);

  return null;
};

export default LegacyRedirectGate;
